<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-05-30 22:42:01
 * @LastEditTime: 2023-07-19 13:55:57
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
    <div class="solution-tab">
        <div class="tab-nav">
            <div class="tab-item" @click="active = index; subActive = 0" :class="{ 'active': active === index }"
                v-for="(item, index) in tabList" :key="index">
                <div>{{ item.title }} </div>
                <div v-show="active === index" class="triangle"></div>
            </div>
        </div>
        <div class="mt--30">
            <div class="row">
                <div class="col-12 mt--30 p-0 solution-tab"
                    :class="[{ 'col-lg-2 col-md-2': $i18n.locale === 'en_US' }, { 'col-lg-1 col-md-1': $i18n.locale === 'zh_CN' || $i18n.locale === 'ja_JP' }]">
                    <div class="left" :class="{ 'active': item.show }" @click="changeSubContent(index)"
                        v-for="(item, index) in tabList[active].content" :key="index">
                        <span>{{ item.title }}</span>
                        <span class="triangle"></span>
                    </div>
                </div>
                <div class="col-12 "
                    :class="[{ 'col-lg-10 col-md-10': $i18n.locale === 'en_US' }, { 'col-lg-11 col-md-11': $i18n.locale === 'zh_CN' || $i18n.locale === 'ja_JP' }]">
                    <div class="tab-content row align-items-center">
                        <div class="col-12 col-lg-4 col-md-4"
                            :class="[`col-lg-${$i18n.locale === 'zh_CN' ? '4' : '6'}`, `col-md-${$i18n.locale === 'zh_CN' ? '4' : '6'}`]">
                            <h5>{{ tabList[active].content[subActive].title }}</h5>
                            <p>{{ tabList[active].content[subActive].description }}</p>
                        </div>
                        <div class="col-12 col-lg-6 col-md-6  text-right"
                            :class="{ 'offset-lg-2': $i18n.locale === 'zh_CN' }">
                            <router-link
                                :to="{ name: tabList[active].content[subActive].routerName, params: { lang: $i18n.locale } }"
                                class="vyung-button mb--30">{{ $t('home.more') }}</router-link>
                            <div class="home-solution-img-h">
                                <img :src="require(`@/assets/images/${tabList[active].content[subActive].image}`)" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'HomeSolutionTab',
    computed: {
        tabList() {
            return [
                {
                    title: 'CRM',
                    content: [
                        {
                            title: this.$t("solution_crm.semiconductor.title"),
                            description: this.$t("solution_crm.semiconductor.header.description"),
                            image: 'home/crm01.jpg',
                            show: true,
                            routerName: "CrmSemiconductor"
                        },
                        {
                            title: this.$t("solution_crm.high-tech.title"),
                            description: this.$t("solution_crm.high-tech.header.description"),
                            image: 'home/crm02.jpg',
                            show: false,
                            routerName: "CrmHighTech"
                        },
                        {
                            title: this.$t("solution_crm.e-consumer.title"),
                            description: this.$t("solution_crm.e-consumer.header.description"),
                            image: 'home/crm03.jpg',
                            show: false,
                            routerName: "CrmElecConsume"
                        },
                        {
                            title: this.$t("solution_crm.new-energy.title"),
                            description: this.$t("solution_crm.new-energy.header.description"),
                            image: 'home/crm04.jpg',
                            show: false,
                            routerName: "CrmNewEnergy"
                        }
                    ],

                },
                {
                    title: 'ERP',
                    content: [
                        {
                            title: this.$t("solution.semiconductor.title"),
                            description: this.$t("solution.semiconductor.header.description"),
                            image: 'home/erp01.jpg',
                            show: true,
                            routerName: "Semiconductor"
                        },
                        {
                            title: this.$t("solution.education.title"),
                            description: this.$t("solution.education.header.description"),
                            image: 'home/erp02.jpg',
                            show: false,
                            routerName: "Education"
                        },
                        {
                            title: this.$t("solution.disperse.title"),
                            description: this.$t("solution.disperse.header.description"),
                            image: 'home/erp03.jpg',
                            show: false,
                            routerName: "Disperse"
                        },
                        {
                            title: this.$t("solution.retail.title"),
                            description: this.$t('solution.retail.header.description'),
                            image: 'home/erp04.jpg',
                            show: false,
                            routerName: "RetailFMCG"
                        },
                        {
                            title: this.$t("solution.automobile.title"),
                            description: this.$t('solution.automobile.header.description'),
                            image: 'home/erp05.jpg',
                            show: false,
                            routerName: "AutomobileAccessory"
                        },
                        {
                            title: this.$t("solution.medicine.title"),
                            description: this.$t('solution.medicine.header.description'),
                            image: 'home/erp06.jpg',
                            show: false,
                            routerName: "Medicine"
                        }
                    ],

                }
            ]
        }
    },
    data() {
        return {
            active: 0,
            subActive: 0
        }
    },
    methods: {

        changeSubContent(index) {
            this.tabList[this.active].content.map(item => item.show = false)
            this.tabList[this.active].content[index].show = true
            this.subActive = index
        }
    }
}
</script>